export enum Occurrences {
  DoNotRepeat = 1,
  Daily = 2,
  EveryWeekday = 3,
  Weekly = 4,
  Monthly = 5,
  Yearly = 6,
}

export enum RepeatUntil {
  EndAfterOccurrences = 1, // "End After # of occurences"
  EndByDate = 2, // "End By Date"
  NoEndDate = 3, // "No End Date"
}

export enum WeekDays {
  Sunday = 1,
  Monday = 2,
  Tuesday = 3,
  Wednesday = 4,
  Thursday = 5,
  Friday = 6,
  Saturday = 7,
}

export const ScheduleTimeType: number = 7;
export const ScheduleTimeSubType: number = 9;

export enum SessionType {
  RelatedServicesAppointment = 1,
  IEPMeetingAttendance = 2,
  NYCPSAuthorizedTraining = 3,
  MeetingWithSchoolStaffAndFamily = 4,
  OnSiteObservation = 5,
  PreparationTime = 6,
  ProviderAbsence = 7,
  TimeSpentEnteringSessionNotes = 8,
  TimeSpentProgressReporting = 9,
}
